"use server";

import {
  getRegistrationInvoice,
  RegistrationInvoiceResponse,
} from "../services/registrationInvoiceService";
import { extractDomain } from "../utils/domain";

export async function getRegistrationInvoiceAction(
  registrationId: string
): Promise<RegistrationInvoiceResponse | null> {
  try {
    const domain = await extractDomain();
    const invoiceData = await getRegistrationInvoice(registrationId, domain);
    return invoiceData;
  } catch (error) {
    console.error("[getRegistrationInvoiceAction] Error:", error);
    return null;
  }
}
